import 'css-chunksrc/client/pages/utilityPage/secondaryCriteriaTemplatePage/styles.scss';export default {
  "secondaryCriteriaTemplatePage": "_secondaryCriteriaTemplatePage_1v31k_1"
};